import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FcpButtonModule, FcpDropdownModule, FcpFormFieldModule, FcpInputModule } from 'fc-ui-components';
import { TranslateModule } from '@ngx-translate/core';
import { UiComponentsModule } from 'shared/ui-components';

import { OrganizationInfoFormComponent } from './organization-info-form.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        UiComponentsModule,
        TranslateModule,
        FcpDropdownModule,
        FcpButtonModule,
        FcpFormFieldModule,
        FcpInputModule
    ],
    declarations: [OrganizationInfoFormComponent],
    exports: [OrganizationInfoFormComponent]
})
export class OrganizationInfoFormModule {}
